<div class="retrieve-payment-container d-flex flex-column gap-4">
  <button type="button" class="btn btn-primary d-flex align-items-center home-btn" (click)="onClick()">
    <i class="fa-solid fa-house me-2"></i>Home
  </button>
  <div>
    <strong>Note: You may take about 5 minutes to complete this transaction.</strong>
  </div>
  <div class="accordion mt-2">
    <div class="card">
      <div class="card-header">
        <button
          class="btn btn-link"
          data-bs-toggle="collapse"
          data-bs-target="#accordion-static"
          aria-expanded="true"
          aria-controls="accordion-static"
          title="Toggle Accordion"
        >
          <span> About this digital service </span>
        </button>
      </div>
      <div id="accordion-static" class="collapse show">
        <div class="card-body">
          <p class="mt-3 mb-1">You will need to enter the following information to retrieve the basic details for payment:</p>
          <ul>
            <li>Payment Advice/Invoice reference number; and</li>
            <li>Payer ID as reflected on the Payment Advice/Invoice/Letter provided by the Singapore Courts, where applicable.</li>
          </ul>
          <p class="mt-3 mb-1"><strong>Online Payment Portal supports electronic payments via:</strong></p>
          <ul>
            <li>PayNow<span style="font-size: 0.7em; vertical-align: super;">recommended</span></li>
            <li>Credit Card (Visa or Mastercard)<span style="font-size: 0.7em; vertical-align: super;">where applicable</span></li>
          </ul>
        </div>

      </div>
    </div>
  </div>
  <div class="p-3 mb-4" style="background-color: #f8f9fa; border-left: 4px solid var(--primary); border-radius: 4px;">
    <span style="font-weight: bold;" class="mt-0 mb-0">Note: </span>
    <span [innerHTML]="checkNote"></span>
  </div>
  <div class="payment-container card p-3 gap-4">
    <span class="title">Court Payments<span *ngIf="paymentType">: {{ paymentTypeMapping[paymentType] || paymentType }}</span></span>
    <div class="p-3" style="background-color: #f8f9fa; border-left: 4px solid var(--primary); border-radius: 4px;">
      <strong>General Information and Instructions:</strong>
      <div class="mt-2 d-flex align-items-center flex-wrap">
    <span class="me-2">
      <ul>
        <li class="mb-2">(*) denotes mandatory field</li>
        <li> Please provide the necessary details below to proceed with payment.</li>
      </ul>
    </span>
        <button type="button"
                class="btn btn-example retrieve-button mt-2 mt-sm-0"
                style="background-color: #b98bcf;"
                data-bs-toggle="modal"
                data-bs-target="#helpModal">
          Where to find the details?
        </button>
      </div>
    </div>

    <div class="modal fade" id="helpModal" tabindex="-1" aria-labelledby="helpModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content border-0 help-modal-content">
          <div class="d-flex flex-column justify-content-between">
            <div class="modal-body mt-0">
              <ul class="nav nav-tabs help-tabs d-flex flex-wrap w-100">
                <li class="nav-item" *ngIf="paymentType === 'COURT_FEE'">
                  <button type="button" class="nav-link active" data-bs-toggle="tab" data-bs-target="#COURT_FEE">Court Fees</button>
                </li>
                <li class="nav-item" *ngIf="paymentType === 'COURT_FINE'">
                  <button type="button" class="nav-link active" data-bs-toggle="tab" data-bs-target="#COURT_FINE">Court Fines</button>
                </li>
                <li class="nav-item" *ngIf="paymentType === 'BAIL_ORDER'">
                  <button type="button" class="nav-link active" data-bs-toggle="tab" data-bs-target="#BAIL_ORDER">Bail/Bond</button>
                </li>
                <ng-container *ngIf="paymentType === 'OTHER_PAYMENTS'">
                  <li class="nav-item">
                    <button type="button" class="nav-link active" data-bs-toggle="tab" data-bs-target="#RENTAL_UTILITIES">Rental & Utilities</button>
                  </li>
                  <li class="nav-item">
                    <button type="button" class="nav-link" data-bs-toggle="tab" data-bs-target="#CAR_PARK">Car Park</button>
                  </li>
                  <li class="nav-item">
                    <button type="button" class="nav-link" data-bs-toggle="tab" data-bs-target="#SJC_INVOICE">SJC Invoice</button>
                  </li>
                  <li class="nav-item">
                    <button type="button" class="nav-link" data-bs-toggle="tab" data-bs-target="#AGENCY_BILLING">Agency Billing Invoice</button>
                  </li>
                  <li class="nav-item">
                    <button type="button" class="nav-link" data-bs-toggle="tab" data-bs-target="#DEPOSITS">Deposits</button>
                  </li>
                </ng-container>
                <li class="nav-item ms-auto d-flex align-items-center">
                  <button type="button"
                          class="nav-link active"
                          data-bs-dismiss="modal"
                          aria-label="Close">
                    <i class="fa-solid fa-xmark fa-xl"></i> </button>
                </li>
              </ul>

              <div class="tab-content">
                <div class="tab-pane fade show active" id="COURT_FEE" *ngIf="paymentType === 'COURT_FEE'">
                  <img src="assets/images/court-fee.png" alt="Court Fee Help" class="img-fluid w-100 help-image"/>
                </div>
                <div class="tab-pane fade show active" id="COURT_FINE" *ngIf="paymentType === 'COURT_FINE'">
                  <img src="assets/images/court-fine.png" alt="Court Fine Help" class="img-fluid w-100 help-image"/>
                </div>
                <div class="tab-pane fade show active" id="BAIL_ORDER" *ngIf="paymentType === 'BAIL_ORDER'">
                  <img src="assets/images/bail-order.png" alt="Bail Order Help" class="img-fluid w-100 help-image"/>
                </div>
                <div class="tab-pane fade show active" id="RENTAL_UTILITIES" *ngIf="paymentType === 'OTHER_PAYMENTS'">
                  <img src="assets/images/invoice-rental-utilities.png" alt="Rental & Utilities" class="img-fluid w-100 help-image"/>
                </div>
                <div class="tab-pane fade" id="CAR_PARK" *ngIf="paymentType === 'OTHER_PAYMENTS'">
                  <img src="assets/images/invoice-car-park.png" alt="Car Park" class="img-fluid w-100 help-image"/>
                </div>
                <div class="tab-pane fade" id="SJC_INVOICE" *ngIf="paymentType === 'OTHER_PAYMENTS'">
                  <img src="assets/images/invoice-sjc.png" alt="SJC Invoice" class="img-fluid w-100 help-image"/>
                </div>
                <div class="tab-pane fade" id="AGENCY_BILLING" *ngIf="paymentType === 'OTHER_PAYMENTS'">
                  <img src="assets/images/invoice-agency-billing.png" alt="Agency Billing" class="img-fluid w-100 help-image"/>
                </div>
                <div class="tab-pane fade" id="DEPOSITS" *ngIf="paymentType === 'OTHER_PAYMENTS'">
                  <img src="assets/images/deposits.png" alt="Deposits" class="img-fluid w-100 help-image"/>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <form (ngSubmit)="onSubmit()" #paymentForm="ngForm" class="d-flex flex-column gap-4">
      <div class="payment-info d-flex flex-column gap-3">
        <div class="form-group">
          <label for="pac-number" class="col-form-label">Payment Reference/Invoice Number</label>
          <strong style="color: red;"> *</strong>
          <input id="pac-number" class="form-control form-control-md vkeyboard"
                 [ngClass]="{'is-invalid': (refNumber.invalid && (refNumber.dirty || refNumber.touched)) || isPacNumberInvalid}"
                 [attr.maxlength]="paymentReferenceNumber?.startsWith('PAC') ? 12 : 9" type="text" #refNumber="ngModel"
                 [(ngModel)]="paymentReferenceNumber" (ngModelChange)="validatePacNumber($event)"
                 name="paymentReferenceNumber" placeholder="eg: XXXXXXXX" required pattern="^[a-zA-Z0-9]*$" autocomplete="off" (paste)="onPaste($event)">
          <div class="text-danger mt-1" *ngIf="refNumber.invalid && (refNumber.dirty || refNumber.touched)">
            <div *ngIf="refNumber.errors?.['required']">
              <span class="error-icon">–</span> Payment Reference/Invoice Number is required.
            </div>
            <div *ngIf="refNumber.errors?.['pattern']">
              <span class="error-icon">–</span> Only letters and numbers allowed.
            </div>
          </div>
          <div class="text-danger mt-1" *ngIf="isPacNumberInvalid">
            <span class="error-icon">–</span> {{ invalidPacNumberError }}
          </div>
        </div>

        <div class="form-group">
          <label for="payer-id" class="col-form-label">Payer ID</label>
          <strong style="color: red;"> *</strong>
          <input id="payer-id" class="form-control form-control-md vkeyboard uppercase-input"
                 [ngClass]="{'is-invalid': (refID.invalid && (refID.dirty || refID.touched)) || isIdNumberValid }"
                 type="text" #refID="ngModel" [(ngModel)]="payerID"
                 name="payerID" placeholder="eg: UEN/NRIC/FIN/ Passport No" required pattern="^[a-zA-Z0-9]*$" autocomplete="off" (paste)="removeSpacesOnPaste($event)">
          <div class="text-danger mt-1" *ngIf="refID.invalid && (refID.dirty || refID.touched)">
            <div *ngIf="refID.errors?.['required']">
              <span class="error-icon">–</span> Payer ID is required.
            </div>
            <div *ngIf="refID.errors?.['pattern']">
              <span class="error-icon">–</span> Only letters and numbers allowed.
            </div>
          </div>
          <div class="text-danger mt-1" *ngIf="isIdNumberValid">
            <span class="error-icon">–</span> {{ isIdNumberValid }}
          </div>
        </div>

        <div class="text-danger mt-1" *ngIf="captchaError">Captcha verification failed. Please try again.</div>

        <app-error-banner
          *ngIf="captchaErrorMessage"
          [message]="captchaErrorMessage">
        </app-error-banner>

        <div class="p-3 mb-4" style="background-color: #f8f9fa; border-left: 4px solid var(--primary); border-radius: 4px;">
          <span style="font-weight: bold;" class="mt-0 mb-0">Note: </span>
          <span [innerHTML]="note"></span>
        </div>

      </div>

      <app-error-banner
        *ngIf="pacErrorMessage"
        [message]="pacErrorMessage">
      </app-error-banner>

      <button type="submit" class="btn btn-primary home-btn d-flex align-self-end retrieve-button"
              [disabled]="!paymentForm.form.valid || isPacNumberInvalid" (click)="clearPacInfoErrorMessages()">
        Retrieve Payment Details
      </button>
    </form>
  </div>
</div>

<app-custom-modal
  #paymentConfirmationModalRef
  [modalId]="'paymentConfirmationModal'"
  [title]="'Important Note'"
  [message]="paymentConfirmationMessage"
  [confirmButtonText]="'Proceed'"
  [cancelButtonText]="'Cancel'"
  [showConfirmOnly]="showConfirmOnly"
  (onCloseModel)="handleConfirmationModalClose($event)">
</app-custom-modal>
<app-virtual-keyboard></app-virtual-keyboard>


